module.exports = __webpack_public_path__ + "static/media/icon-add-section.b1241af5.svg";